/**
 * Case Study — Auto-link product names
 *
 * Reads the product list from [data-case-study-products] JSON and scans every
 * .rte element inside [data-case-study-content]. First occurrence of each
 * product title in each .rte block is wrapped in an <a> pointing to the PDP.
 *
 * Guards:
 *  - Skips text nodes already inside <a> tags
 *  - Skips text inside headings (h1-h6)
 *  - Matches longest product names first to avoid partial matches
 *  - Escapes regex special characters in product titles
 *  - Only links first occurrence per .rte block per product
 */
(function () {
  'use strict';

  function init() {
    var container = document.querySelector('[data-case-study-content]');
    if (!container) return;

    var jsonEl = container.querySelector('[data-case-study-products]');
    if (!jsonEl) return;

    var products;
    try {
      products = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!products || !products.length) return;

    // Sort longest title first so we don't partial-match a shorter name
    products.sort(function (a, b) {
      return b.title.length - a.title.length;
    });

    var rteElements = container.querySelectorAll('.rte');
    rteElements.forEach(function (rte) {
      products.forEach(function (product) {
        linkProduct(rte, product);
      });
    });
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /**
   * Walk text nodes inside `root` and wrap the first occurrence of
   * product.title in an <a> element.
   */
  function linkProduct(root, product) {
    var pattern = new RegExp('(' + escapeRegex(product.title) + ')', 'i');
    var linked = false;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        // Skip if already linked
        if (linked) return NodeFilter.FILTER_REJECT;
        // Skip nodes inside anchors or headings
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('a')) return NodeFilter.FILTER_REJECT;
        if (parent.closest('h1, h2, h3, h4, h5, h6'))
          return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    for (var i = 0; i < textNodes.length; i++) {
      var node = textNodes[i];
      var match = pattern.exec(node.textContent);
      if (!match) continue;

      // Split the text node at the match
      var before = node.textContent.substring(0, match.index);
      var matchedText = match[1];
      var after = node.textContent.substring(match.index + matchedText.length);

      var frag = document.createDocumentFragment();

      if (before) {
        frag.appendChild(document.createTextNode(before));
      }

      var link = document.createElement('a');
      link.href = product.url;
      link.className = 'csv2-product-link';
      link.textContent = matchedText;
      frag.appendChild(link);

      if (after) {
        frag.appendChild(document.createTextNode(after));
      }

      node.parentNode.replaceChild(frag, node);
      linked = true;
      break;
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
